<template>
  <div id="interaction-timeline" class="sm-p-l-5" style="margin-top: 10px;margin-bottom: 10px;" v-if="current_lead">
    <div class="top-circle">
      <section class="timeline">
        <timeline-item 
          v-for="(interaction, idx) in interactions" 
          :key="'interaction-' + idx" 
          :interaction="interaction" 
          @remove-interaction="$emit('remove-interaction', $event)"
          @scheduled-interaction-realized="$emit('scheduled-interaction-realized', $event)"
        >
        </timeline-item>
        
        <div class="timeline-block" >
          <div class="timeline-point success">
            <i class="fa fa-star" ></i>
          </div>
          <div class="timeline-content">
            <div class="card social-card share full-width">
              <div class="card-header clearfix">
                <h5>Crée le {{current_lead.created_at | moment-date  }} <span v-if="get_email_of(current_lead.creating_user_id)"> par {{get_email_of(current_lead.creating_user_id)}} </span>
                </h5>
                <h6>
                  depuis {{ current_lead.decoded_origin }}
                </h6>
              </div>
              <!-- <div class="card-description">
                <p>
                  {{current_lead.origin_message}}
                </p>
                <p>
                  {{current_lead.origin_supplement}}
                </p>
              </div> -->
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapState} from "vuex"
import TimelineItem from "./TimelineItem"
export default {
  name:"Timeline",
  components:{
    TimelineItem,
  },
  computed:{
    ...mapState("crm", ["users"]),
    ...mapGetters("crm", ["current_lead"]),
    readyToRender(){
      return this.interactions !== undefined && this.current_lead != null
    },
    interactions(){
      if (this.current_lead)
        return _.reverse(this.current_lead.interactions)
    }
  },
  methods:{
    ...mapActions("crm", [
        "fetch_interactions",
        "set_fetching_state",
      ]),

      get_email_of(cid){
        var found = _.find(this.users, u => {
          return u.id === cid
        })
        return found != undefined ? found.email : null
      },

      init() {
      }
  },

  created(){
    this.init()
  },

  mounted() {

  },

}
</script>

<style scoped>

div#interaction-timeline {
  max-width:1000px;
}

.timeline::before {
  background:#fc7795;
}

</style>



// WEBPACK FOOTER //
// client/components/CRM/Interactions/Timeline.vue